import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class TotalJobsRaisedByUserReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            url:'/api/v1/portal/portal-admin/total-jobs-raised-by-user-report/',
            downloadUrl:'/api/v1/portal/portal-admin/download-total-jobs-raised-by-user-report/',
            totalUsers:[],
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            filename:'Total Jobs Raised By Users Report',
            isDownloading:false,
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleTotalJobsRaisedByUserReportGenerate(e) {
        this.setState({isLoading: true});
        let url = this.state.url+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              this.setState({
                totalUsers: response.users,
                isLoading: false
              })
            });
          }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }

    downloadableCsvDataTotalJobsRaisedByUser(){
        this.setState({isDownloading: true});
        let url = this.state.downloadUrl+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD");
        let csvFileName = this.state.filename+' From '+moment(this.state.startDate).format("DD_MM_YYYY")+' To '+moment(this.state.endDate).format("DD_MM_YYYY")+'.xlsx';
        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then(response => response.blob())
            .then(blob => {
                this.setState({isDownloading: false});
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = csvFileName;
                document.body.appendChild(a); 
                a.click();    
                a.remove(); 
            }).catch(err=>{
            alert('sorry something went wrong.') ;
        }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }
    render() {
        let totalUsers = [];
        let tableHeaders = [];
        let list = [];
        if(this.state.totalUsers.length > 0){
            let headers = this.state.totalUsers[0];
            Object.keys(headers).forEach(function(key) {
                if(key == 'userID'){
                    return;
                }else if(key == 'full_name'){
                    tableHeaders.push(<th>USER</th>);
                }else{
                    tableHeaders.push(<th>{moment(key).format('DD/MM/YYYY')}</th>);
                } 
            });
          
            totalUsers = this.state.totalUsers.map(crow =>{
                return (
                    <tr key={crow.userID}>
                        {Object.keys(crow).filter(k => k !== 'userID').map(k => {
                            if(k == 'userID'){
                                return;
                            }else{
                                return (
                                    <td key={crow.userID+'-'+k}>{crow[k]}</td>
                                );
                            }
                        })}
                    </tr>
                );
            });
        }else{
            totalUsers.push(
               <tr key='no-records'><td className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Total Jobs Raised Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select Start Date:
                    </div>
                    <div className="col-md-2">
                       Select End Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsRaisedByUserReportGenerate(e)}>
                                <i className="fa fa-download"></i> Generate Total Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvDataTotalJobsRaisedByUser(e)}}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h4>{(this.state.totalUsers.length > 0 ? this.state.totalUsers.length -1 : this.state.totalUsers.length)} users found..</h4>
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                   <tr>{tableHeaders}</tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ? (<tr><td><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totalUsers}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-total_jobs_raised_by_user_report')) {
    ReactDOM.render(
        <TotalJobsRaisedByUserReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-total_jobs_raised_by_user_report')
    );
}
